import CanadaTopPicksLogo from './logo'
import {canadaTopPicksStylesCA} from './styles'

const baseConfig = {
  domainName: 'canadatoppicks' as const,
  domainType: 'maga' as const,
  siteName: 'Canada Top Picks',
  logo: <CanadaTopPicksLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
  favicon: '/favicons/canadatoppicks.png',
}

const localeConfigs = {
  ca: {
    measurementId: 'G-0Z35HKQQL9',
    camelCaseUrl: 'CanadaTopPicks.ca',
    title: (category: string, _count: string) =>
      `Our Top ${category} Picks in CA | Trusted Reviews & Buying Guides | There's 1 Clear Winner `,
    description: (_category?: string, _count?: string) =>
      `Discover Top Rated Products at Today's Lowest Prices, Expert reviews on 1000s of products. Our Buying Guides Help You Get The Best Products for You. Buy Now!`,
    styles: canadaTopPicksStylesCA,
  },
}

export const createConfig = (locale: string = 'ca') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.ca
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
